import {useState} from 'react'
import  Authcode  from './components/Authcode.js'
import Dashboard from './views/Dashboard'
import Home from './views/Home';
import Nav from './components/Nav'
import {
  BrowserRouter as Router,
  Redirect,
  Route
} from "react-router-dom";
import Background from './components/Background.js';
import Footer from './components/Footer.js';
import Generated from './views/Generated.js';

function App() {
  const [code, setCode] = useState();


  const Director = () => {
    if(code) {
      return (
        <Redirect to="/dashboard" />
      )
    } else {
      return (
        <Redirect to="/" />
      )
    }
  }


  return (
    <div className="App">
      <Router>
        <Nav/>
        <Authcode code={code} setCode={setCode}/>
        <Route exact path="/">
          <Home/>
        </Route>
        <Route exact path="/dashboard" render={() => <Dashboard code={code}/> }/>
        <Route exact path="/sample" render={() => <Generated/>}/>
        <Director/>
      </Router>
      <Background/>
      <Footer/>
    </div>
  );
}

export default App;
